import add from 'date-fns/add';

import { ToInteger } from '@shared/sanitizers/number';

import {
  TBaseTemplateSubStageObject,
  TTemplateSubStageShowObject,
  TTemplateSubStageCreateObject,
  TTemplateSubStageUpdateObject,
  TTemplateSubStageDestroyObject,
  TTemplateSubStageObject,
} from '@modules/templates/@types/TTemplateSubStage';
import { TLoggedBranch, TLoggedUser } from '@modules/sessions/@types/TSession';
import {
  ToBaseShowSanitizer,
  ToBaseCreateSanitizer,
  ToBaseUpdateSanitizer,
  ToBaseDestroySanitizer,
  FromBaseApi,
} from '@shared/sanitizers/shared';

function ToBaseSanitizer({
  register,
}: {
  register: TBaseTemplateSubStageObject;
}): TBaseTemplateSubStageObject {
  const parsedObject: TBaseTemplateSubStageObject = {
    template_stage_uuid: register.template_stage_uuid,
    stage_name_uuid: register.stage_name_uuid,
    description: register.description,
    responsible_uuid: register.responsible_uuid,
    status: register.status || undefined,
    estimated_delivery_days: ToInteger(register.estimated_delivery_days || 0),
  };

  return parsedObject;
}

export function ToShow({
  register,
}: {
  register: TTemplateSubStageShowObject;
}): TTemplateSubStageShowObject {
  const parsedObject: TTemplateSubStageShowObject = {
    ...ToBaseShowSanitizer({ register }),
  };

  return parsedObject;
}

export function ToCreate({
  register,
  logged_user,
  logged_branch,
}: {
  register: TTemplateSubStageCreateObject;
  logged_user: TLoggedUser;
  logged_branch: TLoggedBranch;
}): TTemplateSubStageCreateObject {
  const parsedObject: TTemplateSubStageCreateObject = {
    ...ToBaseCreateSanitizer({ register, logged_user, logged_branch }),
    ...ToBaseSanitizer({ register }),
  };

  return parsedObject;
}

export function ToUpdate({
  register,
  logged_user,
  logged_branch,
}: {
  register: TTemplateSubStageUpdateObject;
  logged_user: TLoggedUser;
  logged_branch: TLoggedBranch;
}): TTemplateSubStageUpdateObject {
  const parsedObject: TTemplateSubStageUpdateObject = {
    ...ToBaseUpdateSanitizer({ register, logged_user, logged_branch }),
    ...ToBaseSanitizer({ register }),
  };

  return parsedObject;
}

export function ToDestroy({
  register,
  logged_branch,
}: {
  register: TTemplateSubStageUpdateObject;
  logged_branch: TLoggedBranch;
}): TTemplateSubStageDestroyObject {
  const parsedObject: TTemplateSubStageDestroyObject = {
    ...ToBaseDestroySanitizer({ register, logged_branch }),
  };

  return parsedObject;
}

export function FromApi({
  registers,
}: {
  registers: TTemplateSubStageObject[];
}): TTemplateSubStageObject[] {
  const parsedObjects: TTemplateSubStageObject[] = registers.map(register => ({
    ...register,
    ...FromBaseApi({ registers: [register] })[0],
    estimated_delivery_at: add(new Date(), {
      days: register.estimated_delivery_days || 0,
    }).toISOString(),
  }));

  return parsedObjects;
}
